var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"secondary--text mb-3 mt-5"},[_vm._v("Personal Content Marketing")]),_c('div',{staticClass:"body-1 grey--text text--darken-2"},[_vm._v(" Trustedaccountant.nl lanceert Personal Content Marketing....... ")])])
}]

export { render, staticRenderFns }